import { render } from "./DisabledCheckbox.vue?vue&type=template&id=414de44a"
import script from "./DisabledCheckbox.vue?vue&type=script&lang=js"
export * from "./DisabledCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script